import { createFileRoute } from "@tanstack/react-router";

import { HostedAuth0Redirect } from "@/components/auth/HostedAuth0Redirect";
import { PRODUCT_NAME } from "@/lib/product";

export const Route = createFileRoute("/email-verification")({
  head: () => ({ meta: [{ title: `Verify email · ${PRODUCT_NAME}` }] }),
  component: EmailVerificationPage,
});

function EmailVerificationPage() {
  return <HostedAuth0Redirect />;
}
